module.exports = __webpack_public_path__ + "static/media/laptop.ab491a46.png";